import keyboardShortcutsActionMap from '@/keyboardShortcuts';
import * as coreBi from '@/coreBi';
import { bi } from '@/stateManagement';
import type { EditorAPI } from '@/editorAPI';
import { SWITCH_LAYOUT_PANEL_TYPE } from '@/switchLayout';
import experiment from 'experiment';

const SWITCH_LAYOUT_PANEL_SHORTCUTS_CONFIG = {};
const keyboardMap = keyboardShortcutsActionMap.editor;

function addSwitchLayoutPanelModeShortcuts(editorAPI: EditorAPI) {
  const keysToMerge: Record<string, Function> = {};
  const noop = () => {};
  const stageSizeExperimentIsOpen = experiment.isOpen('se_stageSize');

  keysToMerge[keyboardMap.DELETE.key] = noop;
  keysToMerge[keyboardMap.DUPLICATE.key] = noop;
  keysToMerge[keyboardMap.CLOSE_PANELS.key] = () => {
    const shouldZoomBeFixed = stageSizeExperimentIsOpen
      ? editorAPI.zoomMode.isZoomedByUser()
      : false;

    if (shouldZoomBeFixed) {
      editorAPI.zoomMode.exitZoomMode({
        zoomScale: 0.5,
        biParams: { origin: 'keyboard' },
        clickedByUser: editorAPI.zoomMode.isZoomedByUser(),
      });
    } else {
      editorAPI.zoomMode.exitZoomMode({ biParams: { origin: 'keyboard' } });
    }
    editorAPI.store.dispatch(
      bi.actions.event(coreBi.events.editor.ESCAPE_BUTTON_CLICKED, {
        mode: SWITCH_LAYOUT_PANEL_TYPE,
      }),
    );
  };

  Object.assign(SWITCH_LAYOUT_PANEL_SHORTCUTS_CONFIG, keysToMerge);
}

export default {
  init(editorAPI: EditorAPI) {
    addSwitchLayoutPanelModeShortcuts(editorAPI);
  },
  shortcuts: SWITCH_LAYOUT_PANEL_SHORTCUTS_CONFIG,
};
